import { render, staticRenderFns } from "./RoleOperateColumn.vue?vue&type=template&id=1e246fb0&scoped=true&"
import script from "./RoleOperateColumn.vue?vue&type=script&lang=js&"
export * from "./RoleOperateColumn.vue?vue&type=script&lang=js&"
import style0 from "./RoleOperateColumn.vue?vue&type=style&index=0&id=1e246fb0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e246fb0",
  null
  
)

export default component.exports